export enum InviteToInterviewViews {
  MESSAGE = 'message',
  MESSAGE_SENT = 'messageSent',
  USER_DETAILS = 'userDetails',
}
